import { Account } from "../../interfaces/Account";

export interface AccountState {
	account?: Account;
	isLoading: boolean;
}

export const UPDATE_ACCOUNT = "UPDATE_ACCOUNT";
export const SET_ACCOUNT_IS_LOADING = "SET_ACCOUNT_IS_LOADING";
export const LOGOUT = "ACCOUNT_LOGOUT";
export const GET_ACCOUNT: string = "GET_ACCOUNT";

interface UpdateAccountAction {
	type: typeof UPDATE_ACCOUNT;
	payload: Account;
}

interface SetAccountIsLoadingAction {
	type: typeof SET_ACCOUNT_IS_LOADING;
	payload: boolean;
}

interface AccountLogoutAction {
	type: typeof LOGOUT;
}

export interface GetAcountAction {
	type: typeof GET_ACCOUNT;
	payload: string | undefined;
}

export type AccountActionTypes = UpdateAccountAction | SetAccountIsLoadingAction | AccountLogoutAction | GetAcountAction;
